var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LkFinances'),_c('LkServers')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }